import React, { useEffect } from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import withDefaultParams from "Services/withDefaultParams";
import { pipe } from "Utils/functionalUtils";
import PlanBRowContainer from "Containers/PlanBRowContainer";
import { TariffsTable, TariffsHeaderRow } from "ComponentsUI/TarifficationB";

const TariffTableContainerInCatalog = (props) => {
	let texts = props.ApplicationModel.text;
	let generateTariffs = () => {
		return props.tariffs.map((item) => {
			return (
				<PlanBRowContainer
					key={item.id}
					data={item}
					showName={props.showNames}
					compareIsHide={props.compareIsHide}
					isProviderCatalog={props.isProviderCatalog}
					isRating={props.isRating}
					isRegionRatesTag={props.isRegionRatesTag}
					hideProviderLogo={props.hideProviderLogo}
					pageName={props.pageName}
				/>
			);
		});
	};

	let tableHeader = <TariffsHeaderRow texts={texts} showName={props.showNames} />;
	return (
		<>
			<TariffsTable datatest={props.datatest} tableHeader={tableHeader} isRating={props.isRating}>
				{generateTariffs()}
			</TariffsTable>
		</>
	);
};

export default pipe(
	observer,
	inject("ApplicationModel"),
	withDefaultParams,
	withRouter
)(TariffTableContainerInCatalog);
